import { combineReducers } from 'redux';
import datapoints from './datapoints';

export default combineReducers({
  datapoints
});
